/** @format */

// eslint-disable-next-line @mpb-com/mpb/require-constants-file -- Legacy code: do not use as an example.
export const DEFAULT_TEST_ID = 'product-search-results';
